/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */
import React, {useEffect} from 'react';
import {translate} from '@ion/core/src/locale/locale';
import Dropdown, {Options} from '../components/menus/Dropdown';

export type JobStatusChooserProps = {
  status?: string;
  onChange?: (status: string, label: string) => void;
  classes?: string;
  name?: string;
}

/**
 * Generates the Job status chooser dropdown labels and values based on
 * the translated status entries.
 */
const getOptions = (): Options[] => {
  const entries  = Object.entries(translate('common:jobStatus', {returnObjects: true}));
  const statuses = entries.map(([value, label]) => ({value, label})) as unknown as Options[];
  return statuses;
};

/**
 * The JobStatusChooser provides a list of localized CTC Job Status values for display
 * within a dropdown list and allows the user to select a Status from the list which
 * will be returned to the client as the non-translated CTC Entity Status value.
 *
 * ```typescript
 *
 *     import {JobStatusChooser} from '@ion/dls/src/editors/JobStatusChooser';
 *
 *    // provide an job status specific inline label ...
 *     <JobStatusChooser onChange(setStatus) />
 *
 */
export const JobStatusChooser = ({
  status,
  onChange,
  classes
}: JobStatusChooserProps) => {
  return (
    <div className={classes}>
      <Dropdown displaySelectedLabel
        value={status}
        options={getOptions()}
        fieldLabel={''}
        onChange={onChange ? function(e, target) {
          const {value, label} = target;
          onChange(value, label);
        } : null} />
    </div>
  );
};
export default JobStatusChooser;
